// ─────────────────────────────────────────────────────────────────────────────
// PlaceholderPage — the "under construction" screen. Not a section of its own:
// it stands in for the routes that already have a sidebar entry and an RBAC
// module but no implementation yet (Compliance, Policies — see App.js), so
// those links land somewhere honest instead of on a dead route.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./PlaceholderPage.module.css";

/**
 * @param {object}    props
 * @param {string}    props.title  the section's name, as the sidebar shows it
 * @param {ReactNode} props.icon   that section's glyph (from components/Icons)
 */
export default function PlaceholderPage({ title, icon }) {
  return (
    <div className={styles.page}>
      <div className={styles.icon}>{icon}</div>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.sub}>This page is under construction.</p>
      <div className={styles.bar} />
    </div>
  );
}
